// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const Request = {
    body: (value) => {
        return Object.assign(Object.assign({}, value), { type: "body", _visit: function (visitor) {
                return FernIr.dynamic.Request._visit(this, visitor);
            } });
    },
    inlined: (value) => {
        return Object.assign(Object.assign({}, value), { type: "inlined", _visit: function (visitor) {
                return FernIr.dynamic.Request._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "body":
                return visitor.body(value);
            case "inlined":
                return visitor.inlined(value);
            default:
                return visitor._other(value);
        }
    },
};
